import React from 'react'
import * as Icons from "react-icons/vsc"
import { useDispatch } from 'react-redux';
import { NavLink, matchPath, useLocation } from 'react-router-dom';
import { setEditCourse } from '../../../slices/courseSlice';

const SidebarLink = ({link, iconName}) => {

    const Icon = Icons[iconName];
    const location  = useLocation();
    const dispatch = useDispatch();

    const matchRoute = (route) => {
        return matchPath({path:route}, location.pathname);
    }


  const active = matchRoute(link.path);

  return (
    <NavLink
    to={link.path}
    className={`relative py-2 px-2 text-sm font-medium transition-all duration-300 md:px-8 md:py-2 ${
      active ? "bg-richblack-700 text-richblack-5" : "bg-transparent text-richblack-200 hover:bg-richblack-700/60 hover:text-richblack-5"
    }`}
    >

        

        <div className="flex flex-col items-center gap-x-2 md:flex-row" onClick={
            () => {
                dispatch(setEditCourse(false))
            }
        }>

            <Icon className={`text-3xl md:text-lg ${active ? "text-yellow-50" : "text-richblack-300 md:text-richblack-200"}`} />
            <span className="hidden md:block">{link.name}</span>
            <span className={`absolute bottom-0 left-0 md:top-0 h-[0.2rem] w-full md:h-full md:w-[0.2rem] bg-yellow-50 opacity-0 transition-all duration-300
                  ${active ? "opacity-100": "opacity-0"}`}>
            </span>
        </div>
    </NavLink>
  )
}

export default SidebarLink
